import './Loading.css'

const Loading = () => {
    return <div className='btn-loader'><div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
}

export default Loading